export const TimeRef = {
  "12AM": '12-1 AM',
  "1AM": '1-2 AM',
  "2AM": '2-3 AM',
  "3AM": '3-4 AM',
  "4AM": '4-5 AM',
  "5AM": '5-6 AM',
  "6AM": '6-7 AM',
  "7AM": '7-8 AM',
  "8AM": '8-9 AM',
  "9AM": '9-10 AM',
  "10AM": '10-11 AM',
  "11AM": '11AM - 12PM',
  "12PM": '12-1 PM',
  "1PM": '1-2 PM',
  "2PM": '2-3PM',
  "3PM": '3-4PM',
  "4PM": '4-5 PM',
  "5PM": '5-6 PM',
  "6PM": '6-7 PM',
  "7PM": '7-8 PM',
  "8PM": '8-9 PM',
  "9PM": '9-10 PM',
  "10PM": '10-11 PM',
  "11PM": '11PM - 12AM'
};